import { render, staticRenderFns } from "./nouveausFormations.vue?vue&type=template&id=09401e48&"
import script from "./nouveausFormations.vue?vue&type=script&lang=js&"
export * from "./nouveausFormations.vue?vue&type=script&lang=js&"
import style0 from "./nouveausFormations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports